import {
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  QueryList,
  Renderer2
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormComponent } from '../../components/form/form.component';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';
import { FormGroup, NgControl } from '@angular/forms';

@Directive({
  selector: '[dsdExtFieldsetConnector], dsd-fieldset',
  providers: [
    {
      provide: FormErrorConnectorDirective,
      useExisting: FieldsetConnectorDirective
    }
  ],
  standalone: false
})
export class FieldsetConnectorDirective implements OnInit, OnDestroy {
  formSubmitSubscription: Subscription;
  statusSubscription: Subscription;

  @Input()
  formGroup: FormGroup;

  @ContentChildren(FormErrorConnectorDirective, { descendants: true })
  children: QueryList<FormErrorConnectorDirective>;

  constructor(
    @Optional() private readonly formComponent: FormComponent,
    @Optional() private readonly control: NgControl,
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef
  ) {}

  ngOnInit() {
    if (this.formComponent) {
      this.formSubmitSubscription = this.formComponent.formSubmit.subscribe(() => this.checkForErrors());
    }

    if (this.formGroup) {
      this.statusSubscription = this.formGroup.statusChanges.subscribe(() => this.checkForErrors());
    }
  }

  ngOnDestroy() {
    if (this.formSubmitSubscription) {
      this.formSubmitSubscription.unsubscribe();
    }
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
  }

  private checkForErrors() {
    const shouldBeInError = this.children.some(child => child.hasError);
    if (shouldBeInError) {
      this.setInErrorState();
    } else {
      this.setInValidState();
    }
  }

  private setInErrorState() {
    if (this.control) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'error', 'true');
    } else {
      const legend = this.elementRef.nativeElement.querySelector('[slot=legend]');
      this.renderer.addClass(legend, 'dsd-c-light-error-5');
    }
  }

  private setInValidState() {
    if (this.control) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'error', undefined);
    } else {
      const legend = this.elementRef.nativeElement.querySelector('[slot=legend]');
      this.renderer.removeClass(legend, 'dsd-c-light-error-5');
    }
  }
}
